export default "__VITE_ASSET__Cx8A_rU5__"